/**
 * Authorizable type
 */
export enum AuthorizableType {
  PROJECT = 'project',
  PROJECT_DATASOURCE_TEMPLATE = 'projectDatasourceTemplate',
  PROJECT_DATA_ROLE_TEMPLATE = 'projectDataRoleTemplate',
  PROJECT_FLOW_TEMPLATE = 'projectFlowTemplate',
  PROJECT_METRIC_TEMPLATE = 'projectMetricTemplate',
  PROJECT_PUBLISHED_CONNECTION_TEMPLATE = 'projectPublishedConnectionTemplate',
  PROJECT_WORKBOOK_TEMPLATE = 'projectWorkbookTemplate',
  DATABASE_TABLE_TEMPLATE = 'databaseTableTemplate',
  WORKBOOK = 'workbook',
  VIEW = 'view',
  DATASOURCE = 'datasource',
  FLOW = 'flow',
  DATAROLE = 'dataRole',
  METRIC = 'metric',
  PUBLISHED_CONNECTION = 'publishedConnection',
  DATABASE = 'database',
  TABLE = 'table',
}
